
import { MechanicalAspectMetadataBase } from './mechanical-aspect.metadata.base';


export class MechanicalAspectMetadata extends MechanicalAspectMetadataBase {
  constructor() {
    super();
  }
}

export const MECHANICAL_ASPECT_METADATA: MechanicalAspectMetadata = new MechanicalAspectMetadata();


